import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

// Valley Tickets brand lockup, rendered as crisp inline SVG so it scales to any
// size and adapts to any background via `currentColor` (set a text-* class).
// No PNG dependency -> never appears broken or washed out.
//
// Props:
//   layout: 'horizontal' (default) | 'stacked'
//   withAccent: show the amber brand accent on the mark (default true)
//   className: control color + size, e.g. "h-8 text-white"
const SERIF = "Georgia, 'Times New Roman', Times, serif";

const BrandMark = ({ layout = 'horizontal', withAccent = true, accent = '#fbbf24', className, title = 'Valley Tickets' }) => {
  if (layout === 'stacked') {
    return (
      <svg className={cx('inline-block w-auto', className)} viewBox="0 0 300 132" role="img" aria-label={title} fill="none">
        <rect x="118" y="6" width="64" height="64" stroke="currentColor" strokeWidth="2.5" />
        {withAccent && <rect x="118" y="6" width="22" height="3" fill={accent} />}
        <text x="150" y="54" textAnchor="middle" fontFamily={SERIF} fontSize="44" fill="currentColor">V</text>
        <text x="150" y="112" textAnchor="middle" fontFamily={SERIF} fontSize="21" letterSpacing="7" fill="currentColor">VALLEY TICKETS</text>
      </svg>
    );
  }
  return (
    <svg className={cx('inline-block w-auto', className)} viewBox="0 0 360 72" role="img" aria-label={title} fill="none">
      <rect x="4" y="6" width="60" height="60" stroke="currentColor" strokeWidth="2.5" />
      {withAccent && <rect x="4" y="6" width="20" height="3" fill={accent} />}
      <text x="34" y="50" textAnchor="middle" fontFamily={SERIF} fontSize="40" fill="currentColor">V</text>
      <text x="82" y="48" fontFamily={SERIF} fontSize="25" letterSpacing="4.5" fill="currentColor">VALLEY TICKETS</text>
    </svg>
  );
};

export default BrandMark;
